import { Component, inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { BannerComponent } from '../../shared/components/banner/banner.component';
import { MainLayoutComponent } from '../../shared/components/layouts/main-layout/main-layout.component';
import { Themes } from '../../../themes';

@Component({
  selector: 'ez-already-sent',
  imports: [BannerComponent, MainLayoutComponent],
  templateUrl: './already-sent.component.html',
  styleUrl: './already-sent.component.scss',
})
export class AlreadySentComponent {
  private titleService = inject(Title);

  Themes = Themes;
  constructor() {
    this.titleService.setTitle('Daten bereits abgesendet');
  }
}
